export const MainColor = '#4E3FF4';
export const GrayColor = '#707070';